import styled from 'styled-components';

import { styledSkeleton } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const StyledSkeleton = styled.div`
    display: flex;
    gap: ${tokens.segment.gutter}px;
    height: ${tokens.skeleton.segment.height}px;
`;

export const SkeletonBar = styled.div`
    ${styledSkeleton.baseStyles};
    flex: 1 1 auto;
    height: 100%;
    border-radius: ${tokens.skeleton.bar.radius}px;
    transform: skewX(-20deg);
`;

export const SkeletonMilestone = styled.div`
    display: grid;
    justify-items: end;
    align-content: space-between;
    flex: 0 0 auto;
    width: ${tokens.skeleton.milestone.width}px;
    height: 100%;
`;

export const SkeletonPrice = styled.div`
    ${styledSkeleton.baseStyles};
    width: 50%;
    height: ${tokens.skeleton.milestone.childHeight}px;
    border-radius: ${tokens.skeleton.milestone.radius}px;
`;

export const SkeletonCode = styled.div`
    ${styledSkeleton.baseStyles};
    width: 100%;
    height: ${tokens.skeleton.milestone.childHeight}px;
    border-radius: ${tokens.skeleton.milestone.radius}px;
`;
